import axios from 'axios';
import { TOKEN_KEY } from 'constants/global';
import queryString from 'query-string';

const axiosClientV2 = axios.create({
  baseURL: process.env.REACT_APP_ROOT_API_URL,
  headers: {
    'content-type': 'application/json',
    'x-tenant-id': process.env.REACT_APP_TENANT_ID,
  },
  paramsSerializer: (params) => queryString.stringify(params),
});

axiosClientV2.interceptors.request.use(async (config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

axiosClientV2.interceptors.response.use(
  (response) => {
    if (response && response.data) {
      return response.data;
    }

    return response;
  },
  (error) => {
    // Handle errors
    throw error.response.data;
  }
);

export default axiosClientV2;
